import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-auftrag-list-view',
  imports: [],
  templateUrl: './auftrag.list-view.html',
  styleUrls: ['./auftrag.list-view.css'],
})
export class AuftragListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
